import React, { useState, useRef } from "react";
import "../styles/Home.css";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

const Home = () => {
  const [activeImage, setActiveImage] = useState(null);
  const sliderRef = useRef(null);
  const navigate = useNavigate();
  const { language } = useLanguage();

  const items = [
    {
      title: "Welfare",
      tamiltitle: "வளர்ச்சி",
      description: "Focused on infrastructure growth, technology advancement, and economic progress for the nation.",
      tamildescription: "முதன்மை கட்டமைப்பு வளர்ச்சி, தொழில்நுட்ப முன்னேற்றம் மற்றும் நாட்டின் பொருளாதார முன்னேற்றத்தில் கவனம் செலுத்துகிறோம்.",
      image: "/assets/Container (1).png"
    },
    {
      title: "Governance",
      tamiltitle: "நல்லாட்சி",
      description: "Transparent, accountable, and citizen-centric governance for efficient public services.",
      tamildescription: "வெளிப்படை, பொறுப்பு மற்றும் குடிமக்கள் மைய ஆட்சி திறமையான பொது சேவைகளை வழங்குகிறது.",
      image: "/assets/Container (2).png"
    },
    {
      title: "Development",
      tamiltitle: "தேசிய பாதுகாப்பு",
      description: "Strengthening defense, internal security, and safeguarding national interests.",
      tamildescription: "பாதுகாப்பு, உள் பாதுகாப்பு மற்றும் தேசிய நலன்களை பலப்படுத்துதல்.",
      image: "/assets/Container (3).png"
    },
    {
      title: "Social Justice",
      tamiltitle: "அனைவரையும் உள்ளடக்கிய வளர்ச்சி",
      description: "Ensuring equal opportunities, social justice, and sustainable growth for all communities.",
      tamildescription: "அனைத்து சமூகங்களுக்கும் சம வாய்ப்புகள், சமூக நீதி மற்றும் நிலையான வளர்ச்சி உறுதி செய்கிறோம்.",
      image: "/assets/Container (4).png"
    }
  ];

  const leaders = [
    {
      title: "M.G. Ramachandran",
      tamiltitle: "M.G. Ramachandran",
      description: "PRIME MINISTER",
      tamildescription: "புரட்சித் தலைவர்",
      image: "/assets/mgr.jpg"
    },
    {
      title: "J. Jayalalithaa",
      tamiltitle: "J. Jayalalithaa",
      description: "Former General Secretary",
      tamildescription: "புரட்சித் தலைவி அம்மா",
      image: "/assets/jaya.jpg"
    },
    {
      title: "Edappadi K. Palaniswami",
      tamiltitle: "Edappadi K. Palaniswami",
      description: "General Secretary",
      tamildescription: "மாண்புமிகு பொதுச்செயலாளர்",
      image: "/assets/edapadi.jpg"
    }
  ];

  const galleryImages = [
    "/assets/images/1.jpeg",
    "/assets/images/2.jpeg",
    "/assets/images/3.jpeg",
    "/assets/images/4.jpeg",
    "/assets/images/5.jpeg",
    "/assets/images/6.jpeg",
    "/assets/images/7.jpeg",
    "/assets/images/8.jpeg",
    "/assets/images/9.jpeg",
    "/assets/images/10.jpeg",
    "/assets/images/11.jpeg"
  ];

  const content = {
    maintitle: {
      english: "AIADMK",
      tamil: "AIADMK"
    },
    herouptitle: {
      english: "மாண்புமிகு பொதுச்செயலாளர்",
      tamil: "மாண்புமிகு பொதுச்செயலாளர்"
    },
    heroTitle: {
      english: "Edappadi K. Palaniswami",
      tamil: "Edappadi K. Palaniswami"
    },
    heroSubtitle: {
      english: "General Secretary, AIADMK. Leader of the Opposition, Tamil Nadu Legislative Assembly",
      tamil: "General Secretary, AIADMK. Leader of the Opposition, Tamil Nadu Legislative Assembly"
    },
    heroTagline: {
      english: "Continuing the legacy of Puratchi Thalaivar MGR and Puratchi Thalaivi Amma. Dedicated to the welfare, development, and social justice of Tamil Nadu.",
      tamil: "அனைவருடனும், அனைவரின் வளர்ச்சிக்காகவும், அனைவரின் நம்பிக்கையுடனும்."
    },
    coreFocus: {
      english: "Our Core Focus",
      tamil: "எங்கள் முக்கிய கவனம்"
    },
    leadership: {
      english: "Leadership Legacy",
      tamil: "தலைமைத்துவ மரபு"
    },
    transformingIndia: {
      english: "Transforming India",
      tamil: "இந்தியாவை மாற்றியமைத்தல்"
    },
    transformingDescription: {
      english: "Through visionary policies and relentless execution, building the foundation for a developed nation.",
      tamil: "தொலைநோக்கு கொள்கைகள் மற்றும் தளராத செயல்பாட்டின் மூலம், ஒரு வளர்ந்த நாட்டின் அடித்தளத்தை கட்டி எழுப்புகிறோம்."
    },
    viewAchievements: {
      english: "View All Achievements",
      tamil: "அனைத்து சாதனைகளையும் காண்க"
    },
    galleryTitle: {
      english: "Moments & Activities",
      tamil: "நிகழ்வுகள் & செயல்பாடுகள்"
    },
    joinMovement: {
      english: "Join us in building a prosperous Tamil Nadu",
      tamil: "இயக்கத்தில் சேருங்கள்"
    },
    joinDescription: {
      english: "Connect with AIADMK. Your voice matters to us. Reach out through any of our official channels.",
      tamil: "தேசம் கட்டும் பணியில் பங்கேற்கவும். இன்றே எங்களுடன் தொடர்பு கொள்ளுங்கள்."
    },
    infrastructure: {
      english: "Roads & Transport",
      tamil: "உள்கட்டமைப்பு"
    },
    infrastructure1: {
      english: "World-class connectivity",
      tamil: "World-class connectivity"
    },
    digitalIndia: {
      english: "Water Management",
      tamil: "டிஜிட்டல் இந்தியா"
    },
    digitalIndia1: {
      english: "Sustainable Solutions",
      tamil: "Sustainable Solutions"
    },
    education: {
      english: "Education",
      tamil: "கல்வி"
    },
    education1: {
      english: "Knowledge Revolution",
      tamil: "Knowledge Revolution"
    },
    healthcare: {
      english: "Healthcare",
      tamil: "சுகாதாரம்"
    },
    healthcare1: {
      english: "Healthcare for All",
      tamil: "சுகாதாரம்"
    }
  };

  return (
    <>
      <section className="hero">
        <div className="hero-container">
          <div className="hero-left">
            <h1 className="maintitle">{content.maintitle[language]}</h1>
            <h1 className="herouptitle">{content.herouptitle[language]}</h1>
            <h1 className="nammeee">{content.heroTitle[language]}</h1>
            <p>
              {content.heroSubtitle[language]}
            </p>
            <p className="lighttext">{content.heroTagline[language]}</p>
            <div className="hero-buttons">
              <button
                className="outline"
                onClick={() => navigate("/Mission-vission")}
              >
                {language === 'tamil' ? 'குறிக்கோள் & பார்வை' : 'Mission & Vision'}
              </button>

              <button
                className="outline"
                onClick={() => navigate("/About")}
              >
                {language === 'tamil' ? 'எங்களை பற்றி' : 'About Us'}
              </button>

              <button
                className="outline"
                onClick={() => navigate("/Contact")}
              >
                {language === 'tamil' ? 'தொடர்பு கொள்ளுங்கள்' : 'Contact Us'}
              </button>
            </div>
          </div>

          <div className="hero-right">
            <div className="image-card">
              <div className="image-placeholder"><img src="/assets/edapadi.jpg" alt="" /></div>
            </div>
          </div>
        </div>
      </section>
      <section className="core-focus">
        <h2 className="coretitle">{content.coreFocus[language]}</h2>
        <div className="focus-grid">
          {items.map((item, i) => (
            <div key={i} className="focus-card">
              <img src={item.image} alt="" />
              <h4>{language === 'tamil' ? item.tamiltitle : item.title}</h4>
              <p>{language === 'tamil' ? item.tamildescription : item.description}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="leadership">
        <h2 className="coretitle">{content.leadership[language]}</h2>
        <div className="leader-grid">
          {leaders.map((leader, i) => (
            <div key={i} className={`leader-card`}>
              <img src={leader.image} alt="" className="leader-img" />
              <p className="tamildess">{language === 'tamil' ? leader.tamildescription : leader.tamildescription}</p>
              <h4 className="leadtitle">{language === 'tamil' ? leader.tamiltitle : leader.title}</h4>
              <p className="leaddesc">{language === 'tamil' ? leader.tamildescription : leader.description}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="transform">
        <div className="transform-left">
          <div>
            <h2 className="transform-left1">{content.transformingIndia[language]}</h2>
            <p className="transform-left3">
              {content.transformingDescription[language]}
            </p>
          </div>
          <button onClick={() => navigate("/Mission-vission")} className="outline">{content.viewAchievements[language]}</button>
        </div>

        <div className="transform-right">
          <div className="icon-card">
            <span className="transimg"><img src="/assets/Container (5).png" alt="" /></span>
            <div className="iconcardd">
              <h1>{content.infrastructure[language]}</h1>
              <p> {content.infrastructure1[language]}</p>
            </div>
          </div>
          <div className="icon-card">
            <span className="transimg"><img src="/assets/Container (6).png" alt="" /></span>
            <div className="iconcardd">
              <h1>{content.digitalIndia[language]}</h1>
              <p>{content.digitalIndia1[language]}</p>
            </div>
          </div>
          <div className="icon-card">
            <span className="transimg"><img src="/assets/Container (7).png" alt="" /></span>
            <div className="iconcardd">
              <h1>{content.education[language]}</h1>
              <p>{content.education1[language]}</p>
            </div>
          </div>
          <div className="icon-card">
            <span className="transimg"><img src="/assets/Container (8).png" alt="" /></span>
            <div className="iconcardd">
              <h1>{content.healthcare[language]}</h1>
              <p>{content.healthcare1[language]}</p>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="gallery">
        <h2 className="coretitle">{content.galleryTitle[language]}</h2>

        <div className="masonry">
          {galleryImages.map((img, i) => (
            <div
              key={i}
              className="masonry-item animate"
              onClick={() => setActiveImage(i)}
            >
              <img src={img} alt="" />
            </div>
          ))}
        </div>
      </section> */}

      <section className="join">
        <div className="joinit">
          <h2>{content.joinMovement[language]}</h2>
          <p>{content.joinDescription[language]}</p>
          <div className="joining1">
            <div  className="joining11">
              <img src="/assets/Container (9).png" alt="" />
              <div className="joining21">
                <h1>Head Office</h1>
                <p>Royapettah, Chennai</p>
              </div>
            </div>
            <div  className="joining11">
              <img src="/assets/Container (10).png" alt="" />
              <div  className="joining21">
                <h1>Helpline</h1>
                <p>+91 44 2813 2266</p>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-boxes">
          <h1>Get in Touch</h1>
          <div className="contact-boxespar par1">
            <img src="/assets/Frame (1).png" alt="" /> Call Now
          </div>
          <div className="contact-boxespar par2">
            <img src="/assets/Frame.png" alt="" /> Whatsapp
          </div>
          <div className="contact-boxespar par3">
            <img src="/assets/Frame (2).png" alt="" /> Email Us
          </div>
        </div>
      </section>
      {activeImage !== null && (
        <div className="fullscreen" onClick={() => setActiveImage(null)}>
          <span className="close">×</span>

          <div
            className="fullscreen-slider"
            ref={sliderRef}
            onTouchStart={(e) =>
              (sliderRef.current.startX = e.touches[0].clientX)
            }
            onTouchEnd={(e) => {
              const diff =
                sliderRef.current.startX - e.changedTouches[0].clientX;
              if (diff > 50 && activeImage < galleryImages.length - 1)
                setActiveImage(activeImage + 1);
              if (diff < -50 && activeImage > 0)
                setActiveImage(activeImage - 1);
            }}
          >
            <img src={galleryImages[activeImage]} alt="" />
          </div>
        </div>
      )}
    </>
  );
};

export default Home;